import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-accent-700 font-medium whitespace-nowrap">网友热评</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
            吃瓜群众 · 真实锐评
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            来自全网吃瓜群众的热门评论，看看大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < comment.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-background-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {comment.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.username}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {comment.username}
                  </p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}